import axios from 'axios';

//正式服
let base = 'https://admin-sdk-api.y7y.net/';

//beta服
//let base = 'https://beta-sdk-api.y7y.net/';



export const baseUrl = base ;
//登录 
export const slogin = params => { return axios.post(`${base}user/login`, params).then(res => res.data); };
//上传图片 
export const supload = (token) => { return axios.post(`${base}user/upload`,{ 
    headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'token':token
            }
}).then(res => res.data); };
//用户菜单 
export const smenu = (token) => { return axios.get(`${base}user/menu?from=1`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//用户配置 
export const sconfig = (token) => { return axios.get(`${base}setting/index`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//产品列表
export const splist = (p,token) => { return axios.get(`${base}product/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//新建创意选择的产品列表
export const newsplist = (p,token) => { return axios.get(`${base}product/creative`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };



//新增产品
export const saddp = (p,token) => { return axios.post(`${base}product/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//产品复用
export const scopy = (p,token) => { return axios.get(`${base}product/copy?kw=${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//编辑产品
export const seditp = (p,token) => { return axios.post(`${base}product/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//产品状态
export const spstatus = (p,token) => { return axios.post(`${base}product/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//产品更新日志
export const splog = (p,token) => { return axios.get(`${base}product/log&index_id=${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//更新日志 列表
export const logList = (p,token) => { return axios.get(`${base}log/page?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//广告创意更新日志
export const sclog = (p,token) => { return axios.get(`${base}log/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//创意列表
export const sclist = (p,token) => { return axios.get(`${base}creative/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//新增创意
export const saddc = (p,token) => { return axios.post(`${base}creative/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//编辑创意
export const seditc = (p,token) => { return axios.post(`${base}creative/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//创意状态
export const scstatus = (p,token) => { return axios.post(`${base}creative/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//创意组合列表
export const sglist = (p,token) => { return axios.get(`${base}creativeBale/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//创意组合状态
export const sgstatus = (p,token) => { return axios.post(`${base}creativeBale/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//新增创意组合
export const saddg = (p,token) => { return axios.post(`${base}creativeBale/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//编辑创意组合
export const seditg = (p,token) => { return axios.post(`${base}creativeBale/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//创意组合单个
export const sgone = (p,token) => { return axios.get(`${base}creativeBale/edit?creativebale_id=${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//广告位列表
export const sadlist = (p,token) => { return axios.get(`${base}space/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//新增广告位
export const saddad = (p,token) => { return axios.post(`${base}space/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//编辑广告位
export const seditad = (p,token) => { return axios.post(`${base}space/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//广告位状态
export const sadstatus = (p,token) => { return axios.post(`${base}space/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//广告投放列表
export const sadtou = (p,token) => { return axios.get(`${base}plan/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//广告投放单个
export const sonetou = (p,token) => { return axios.get(`${base}plan/edit?plan_id=${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//新增广告投放
export const saddtou = (p,token) => { return axios.post(`${base}plan/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//编辑广告投放
export const sedittou = (p,token) => { return axios.post(`${base}plan/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//广告投放状态
export const stoustatus = (p,token) => { return axios.post(`${base}plan/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//广告投放 - 广告位筛选
export const sadfilter = (p,token) => { return axios.get(`${base}space/filter?valid=1&${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//广告创意数据
export const scdata = (p,token) => { return axios.get(`${base}creativeData/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//广告创意按照投放位置维度进行展示
export const sc2data = (p,token) => { return axios.get(`${base}creativeData/placement?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };



//广告创意2按照投放位置维度进行展示
export const sc2data2 = (p,token) => { return axios.get(`${base}creativeData/product?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };




//广告创意 临时  按照投放位置维度进行展示
export const sc2data3 = (p,token) => { return axios.get(`${base}CreativeData/cindex?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//广告创意按照投放位置维度多天进行展示
export const sc2dataDay = (p,token) => { return axios.get(`${base}creativeData/day?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//创意详情数据
export const scdetail = (p,token) => { return axios.get(`${base}creativeData/detail?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//广告位数据
export const saddata = (p,token) => { return axios.get(`${base}spaceData/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//广告位详情数据
export const saddetail = (p,token) => { return axios.get(`${base}spaceData/detail?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//产品收入
export const sidata = (p,token) => { return axios.get(`${base}income/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//产品收入2
export const sidata2 = (p,token) => { return axios.get(`${base}income/product?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//产品收入 临时
export const sidata3 = (p,token) => { return axios.get(`${base}income/cindex?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//产品计价更新
export const spupdate = (p,token) => { return axios.post(`${base}income/update`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//产品计价更新2
export const spupdate2 = (p,token) => { return axios.post(`${base}income/num`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//skd版本信息列表
export const slist = (p,token) => { return axios.get(`${base}version/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//skd版本信息单个
export const soinfo = (p,token) => { return axios.get(`${base}version/edit?version_id=${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//编辑skd版本
export const seditversion = (p,token) => { return axios.post(`${base}version/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//新增skd版本
export const saddversion = (p,token) => { return axios.post(`${base}version/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//skd投放列表
export const svlist = (p,token) => { return axios.get(`${base}serving/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//skd投放单个
export const svs = (p,token) => { return axios.get(`${base}serving/edit?serving_id=${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//新增skd投放列表
export const saddsdk = (p,token) => { return axios.post(`${base}serving/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//编辑skd投放列表
export const seditsdk = (p,token) => { return axios.post(`${base}serving/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//更改skd投放状态
export const sdkstatus = (p,token) => { return axios.post(`${base}serving/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//小程序筛选
export const swxapp = (p,token) => { return axios.get(`${base}IssuedApp/filter?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//修改密码
export const scpwd = (p,token) => { return axios.post(`${base}user/password`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//静态化配置
export const pconfig = (p1,p2,token) => { return axios.get(`${base}plan/config?index_id=${p1}&type=${p2}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//一键分配收入
export const sOneKey = (id,p,token) => { return axios.get(`${base}income/autoUpdate?index_id=${id}&d_date=${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//一键分配收入2
export const sOneKey2 = (id,p,token) => { return axios.get(`${base}income/auto?index_id=${id}&d_date=${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//一键同步收入
export const sOnePrice2 = (id,p,token) => { return axios.get(`${base}income/sync?index_id=${id}&d_date=${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//产品收入展开数据
export const pdataEx = (p,token) => { return axios.get(`${base}income/day?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//产品收入2展开数据
export const pdataEx2 = (p,token) => { return axios.get(`${base}income/date?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//产品创意展开数据
export const cdataEx = (p,token) => { return axios.get(`${base}creativeData/day?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//产品创意按创意展开数据2
export const cdataEx2 = (p,token) => { return axios.get(`${base}CreativeData/creative?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//产品创意按天数展开数据
export const cdataEx3 = (p,token) => { return axios.get(`${base}CreativeData/date?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//产品广告展开数据
export const addataEx = (p,token) => { return axios.get(`${base}spaceData/day?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//屏蔽策略列表
export const rulesList = (p,token) => { return axios.get(`${base}shieldRule/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//屏蔽策略添加
export const rulesAdd = (p,token) => { return axios.post(`${base}shieldRule/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//屏蔽策略编辑
export const rulesEdit = (p,token) => { return axios.post(`${base}shieldRule/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };




//屏蔽策略状态
export const ruleStatus = (p,token) => { return axios.post(`${base}shieldRule/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//扣量策略 - 列表



export const rulesAldList = (p,token) => { return axios.get(`${base}shieldAld/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//扣量规则 - 列表
export const rulesAldDetailList = (p,token) => { return axios.get(`${base}shieldAld/edit?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };



//增加扣量策略
export const rulesAldAdd = (p,token) => { return axios.post(`${base}shieldAld/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//编辑扣量策略
export const rulesAldEdit = (p,token) => { return axios.post(`${base}shieldAld/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//扣量策略状态
export const aldStatus = (p,token) => { return axios.post(`${base}shieldAld/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//扣量策略批量增加
export const aldbatchAdd = (p,token) => { return axios.post(`${base}shieldAld/batch`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//扣量策略批量删除
export const aldbatchDelete = (p,token) => { return axios.post(`${base}shieldAld/delete`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//设备管理列表
export const getSettingList = (p,token) => { return axios.get(`${base}setting/list?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//获取设置管理单个

export const getSettingListByID = (p,token) => { return axios.get(`${base}setting/edit?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//新增设置管理
export const saddSetting = (p,token) => { return axios.post(`${base}setting/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
   



//编辑设置管理
export const seditSetting = (p,token) => { return axios.post(`${base}setting/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//获取账号列表
export const getPlist = (p,token) => { return axios.get(`${base}plan/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };










// WEBPACK FOOTER //
// ./src/api/api.js